import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=0428b8fa&scoped=true&"
import script from "./FooterPage.vue?vue&type=script&lang=js&"
export * from "./FooterPage.vue?vue&type=script&lang=js&"
import style0 from "./FooterPage.vue?vue&type=style&index=0&id=0428b8fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428b8fa",
  null
  
)

export default component.exports